import { useState, useEffect } from 'react'
import { Switch, useRouteMatch, Route } from 'react-router-dom'

import questionsContext from '../../context/questions'
import tagsContext from '../../context/tags'

import getQuestions from '../../api/questions'
import getTags from '../../api/tags'

import List from './List'
import Single from './Single'
import NewQuestion from './New'


function Questions() {
    const [questions, setQuestions] = useState([])
    const [tags, setTags] = useState([])

    useEffect(() => {
        const fetchData = async () => {
            const ts = await getTags()
            const qs = await getQuestions()
            setTags(ts)
            setQuestions(qs)
        }
        fetchData()
    }, [])

    const { path } = useRouteMatch()

    return <>
        <questionsContext.Provider value={questions}>
            <tagsContext.Provider value={tags}>
                <Switch>
                    <Route path={path} component={List} exact />
                    <Route path={path + '/new'} component={NewQuestion} exact />
                    {/* TODO: Edit question path with query parameters */}
                    <Route path={path + '/:id'} component={Single} />
                </Switch>
            </tagsContext.Provider>
        </questionsContext.Provider>
    </>
}


export default Questions
